<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper">
    <div class="card">
        <div class="card-body">
            <table class="table" #btable>
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">เลขแปลง</th>
                        <th scope="col">เจ้าของแปลง</th>
                        <th scope="col">พื้นที่</th>
                        <th scope="col">ประเภทอ้อย</th>
                        <th scope="col">สถานะการปลูก</th>
                        <th scope="col">วันที่นำเข้าแปลง</th>
                        <th scope="col">ผ่านมาแล้ว(วัน)</th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of erplant; index as i">
                        <td>{{i+1}}</td>
                        <td>{{item.intlandno}}</td>
                        <td>{{item.fmcode +' '+ item.fmname}}</td>
                        <td>{{item.landvalue | number}}</td>
                        <td>{{item.CaneTypeName}}</td>
                        <td>{{item.growed1}}</td>
                        <td>{{item.creDt_th}}</td>
                        <td>{{item.insertDateDiff}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<app-footer></app-footer>